import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function(state = getInitialState.list(), action) {
  switch (action.type) {
    case actionTypes.ASSET_AUDITORS_CLEAR: {
      return getInitialState.list();
    }
    case actionTypes.ASSET_AUDITORS_SET: {
      const { assetAuditors } = action.payload;
      return helpers.getListReducer(state, assetAuditors);
    }
    case actionTypes.ASSET_AUDITORS_MERGE: {
      const { assetAuditors } = action.payload;
      return helpers.mergeListReducer(state, assetAuditors);
    }
    default: {
      return state;
    }
  }
}
